export const settingMenus = () => ({
    Id: 14,
    id: `main-menu-2-all`,
    path: '/management/settings/logistics',
    label: 'Settings',
    Description: 'Settings panel enables the user to configure the appearance or actions in an platform..',
    isEnabled: true,
    svg: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-6 w-6  mr-2" color="#ffffff" fill="none">
            <path d="M15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12Z" stroke="#ffffff" strokeWidth="1.5"></path>
            <path d="M21.011 14.0965C21.5329 13.9558 21.7939 13.8854 21.8969 13.7508C22 13.6163 22 13.3998 22 12.9669V11.0332C22 10.6003 22 10.3838 21.8969 10.2493C21.7938 10.1147 21.5329 10.0443 21.011 9.90358C19.0606 9.37759 17.8399 7.33851 18.3433 5.40087C18.4817 4.86799 18.5509 4.60156 18.4848 4.44529C18.4187 4.28902 18.2291 4.18134 17.8497 3.96596L16.125 2.98673C15.7528 2.77539 15.5667 2.66972 15.3997 2.69222C15.2326 2.71472 15.0442 2.90273 14.6672 3.27873C13.208 4.73448 10.7936 4.73442 9.33434 3.27864C8.95743 2.90263 8.76898 2.71463 8.60193 2.69212C8.43489 2.66962 8.24877 2.77529 7.87653 2.98663L6.15184 3.96587C5.77253 4.18123 5.58287 4.28891 5.51678 4.44515C5.45068 4.6014 5.51987 4.86787 5.65825 5.4008C6.16137 7.3385 4.93972 9.37763 2.98902 9.9036C2.46712 10.0443 2.20617 10.1147 2.10308 10.2492C2 10.3838 2 10.6003 2 11.0332V12.9669C2 13.3998 2 13.6163 2.10308 13.7508C2.20615 13.8854 2.46711 13.9558 2.98902 14.0965C4.9394 14.6225 6.16008 16.6616 5.65672 18.5992C5.51829 19.1321 5.44907 19.3985 5.51516 19.5548C5.58126 19.7111 5.77092 19.8188 6.15025 20.0341L7.87495 21.0134C8.24721 21.2247 8.43334 21.3304 8.6004 21.3079C8.76746 21.2854 8.95588 21.0973 9.33271 20.7213C10.7927 19.2644 13.2088 19.2643 14.6689 20.7212C15.0457 21.0973 15.2341 21.2853 15.4012 21.3078C15.5682 21.3303 15.7544 21.2246 16.1266 21.0133L17.8513 20.034C18.2307 19.8187 18.4204 19.711 18.4864 19.5547C18.5525 19.3984 18.4833 19.132 18.3448 18.5991C17.8412 16.6616 19.0609 14.6226 21.011 14.0965Z" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round"></path>
        </svg>
    ),
    subMenu: [
        {
            id: `coln-1-Categories`,
            label: 'Logistics Settings',
            path: '/management/settings/logistics',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),

        },
        {
            id: `coln-1-collections`,
            label: 'Catalog Settings',
            path: '/management/settings/catalog',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'CRM Settings',
            path: '/management/settings/crm',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'DOM Settings',
            path: '/management/settings/dom',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Marketing Settings',
            path: '/management/settings/marketing',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'eProcurement Settings',
            path: '/management/settings/e-procurements',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Production Settings',
            path: '/management/settings/productions',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'eApplication Settings',
            path: '/management/settings/e-applications',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Transport Settings',
            path: '/management/settings/transport',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'CMS Settings',
            path: '/management/settings/cms',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-collections`,
            label: 'Organization Settings',
            path: '/management/settings/organizations',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
        },
        {
            id: `coln-1-Categories`,
            label: 'Global Settings',
            path: '/management/settings/global-settings/global',
            isEnabled: true,
            svg: (
                <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                    <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                    <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                </svg>
            ),
            subMenu: [
                {
                    id: `coln-1-collections`,
                    label: 'Global Settings',
                    path: '/management/settings/global-settings/global',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                            <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                            <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                        </svg>
                    ),
                },
                {
                    id: `coln-1-collections`,
                    label: 'Tags',
                    path: '/management/settings/global-settings/tags',
                    isEnabled: true,
                    svg: (
                        <svg className="h-6 w-6 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" fill="none" stroke="#007BFF" strokeWidth="2" />
                            <path d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0z" fill="#007BFF" />
                            <path d="M22 12c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6 6 2.69 6 6z" fill="#007BFF" />
                        </svg>
                    ),
                },
            ],
        }
    ],
}
)
